<template>
  <el-form
    :model="config"
    style="width: 100%">
    <el-form-item
      v-for="(list, index) in config.list"
      :label="`题目${index+1}`"
      :key="index"
      class="game-list-editor__recorder"
    >
      <el-row class="config_box">
        <el-col :span="9">
          <el-row>
            <el-col
              :span="24">
              <el-row>
                <el-col
                  :span="8">
                  <el-row
                    v-for="(image, innerIndex) in list.title.image"
                    :key="innerIndex">
                    <el-col :span="24">
                      <FileDialog
                        v-model="image.image"
                        :title="image.image"
                        token-url="/upload/token"
                        token-mode="type"
                        width="140px"
                        height="40px"
                        type="image"
                        preview
                      >
                        <span
                          slot="placeholder"
                          class="layout-placeholder"
                        >
                          选择图片
                        </span>
                      </FileDialog>
                      <AppIcon
                        type="delete"
                        @click="() => DeleteTitle(index, innerIndex, 'image')"
                      />
                    </el-col>
                  </el-row>
                  <el-button
                    size="small"
                    icon="el-icon-plus"
                    @click="AppendTitle(index, 'image')"
                  >
                    添加图片资源
                  </el-button>
                </el-col>
                <el-col
                  :span="8">
                  <el-row
                    v-for="(audio, innerIndex) in list.title.audio"
                    :key="innerIndex">
                    <el-col :span="24">
                      <FileDialog
                        v-model="audio.audio"
                        :title="audio.audio"
                        token-url="/upload/token"
                        token-mode="type"
                        width="140px"
                        height="40px"
                        type="audio"
                        preview
                      >
                        <span
                          slot="placeholder"
                          class="layout-placeholder"
                        >
                          选择音频
                        </span>
                      </FileDialog>
                      <AppIcon
                        type="delete"
                        @click="() => DeleteTitle(index, innerIndex, 'audio')"
                      />
                    </el-col>
                  </el-row>
                  <el-button
                    size="small"
                    icon="el-icon-plus"
                    @click="AppendTitle(index, 'audio')"
                  >
                    添加音频资源
                  </el-button>
                </el-col>
                <el-col
                  :span="8">
                  <el-row
                    v-for="(text, innerIndex) in list.title.text"
                    :key="innerIndex">
                    <el-col :span="16">
                      <el-input
                        v-model="text.text"
                        :autosize="true"
                        type="textarea"
                        resize="none"
                        placeholder="请输入对应内容"
                      />
                    </el-col>
                    <el-col :span="2">
                      <AppIcon
                        type="delete"
                        @click="() => DeleteTitle(index, innerIndex, 'text')"
                      />
                    </el-col>
                  </el-row>
                  <el-button
                    size="small"
                    icon="el-icon-plus"
                    @click="AppendTitle(index, 'text')"
                  >
                    添加对应内容
                  </el-button>
                </el-col>
              </el-row>
            </el-col>
          </el-row>
        </el-col>
        <el-col :span="14">
          <el-row>
            <el-col :span="1">
              选项
            </el-col>
            <el-col :span="3">
              <el-select
                v-model="options[index].optionsValue"
                placeholder="请选择"
                @change="changeOptions(index)">
                <el-option
                  v-for="item in options[index].optionsSelect"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"/>
              </el-select>
            </el-col>
            <el-col
              :span="19"
              style="margin-left: 20px;">
              <el-row>
                <!--图片-->
                <el-col
                  v-if="options[index].optionsValue === 'image'"
                  :span="24">
                  <el-row
                    v-for="(image, innerIndex) in list.options"
                    :key="innerIndex">
                    <el-col :span="7">
                      <FileDialog
                        v-model="image.image"
                        :title="image.image"
                        token-url="/upload/token"
                        token-mode="type"
                        width="140px"
                        height="40px"
                        type="image"
                        preview
                      >
                        <span
                          slot="placeholder"
                          class="layout-placeholder"
                        >
                          选择图片
                        </span>
                      </FileDialog>
                      <AppIcon
                        type="delete"
                        @click="() => DeleteOptions(index, innerIndex, 'image')"
                      />
                    </el-col>
                    <el-col :span="3">
                      <el-radio
                        v-model="optionsIsTrue[index].isTrue"
                        :label="innerIndex"
                        @change="changeRadio(index, innerIndex)">正确答案</el-radio>
                    </el-col>
                  </el-row>
                  <el-button
                    size="small"
                    icon="el-icon-plus"
                    @click="AppendOptions(index)"
                  >
                    添加选项
                  </el-button>
                </el-col>
                <!--音频-->
                <el-col
                  v-else-if="options[index].optionsValue === 'audio'"
                  :span="24">
                  <el-row
                    v-for="(audio, innerIndex) in list.options"
                    :key="innerIndex">
                    <el-col :span="7">
                      <FileDialog
                        v-model="audio.audio"
                        :title="audio.audio"
                        token-url="/upload/token"
                        token-mode="type"
                        width="140px"
                        height="40px"
                        type="audio"
                        preview
                      >
                        <span
                          slot="placeholder"
                          class="layout-placeholder"
                        >
                          选择音频
                        </span>
                      </FileDialog>
                      <AppIcon
                        type="delete"
                        @click="() => DeleteOptions(index, innerIndex, 'audio')"
                      />
                    </el-col>
                    <el-col :span="3">
                      <el-radio
                        v-model="optionsIsTrue[index].isTrue"
                        :label="innerIndex"
                        @change="changeRadio(index, innerIndex)">正确答案</el-radio>
                    </el-col>
                  </el-row>
                  <el-button
                    size="small"
                    icon="el-icon-plus"
                    @click="AppendOptions(index)"
                  >
                    添加选项
                  </el-button>
                </el-col>
                <!--文本-->
                <el-col
                  v-else-if="options[index].optionsValue === 'text'"
                  :span="24">
                  <el-row
                    v-for="(text, innerIndex) in list.options"
                    :key="innerIndex">
                    <el-col :span="7">
                      <el-input
                        v-model="text.text"
                        :autosize="true"
                        type="textarea"
                        resize="none"
                        class="optionsInput"
                        placeholder="请输入对应内容"
                      />
                      <AppIcon
                        type="delete"
                        @click="() => DeleteOptions(index, innerIndex, 'text')"
                      />
                    </el-col>
                    <el-col :span="3">
                      <el-radio
                        v-model="optionsIsTrue[index].isTrue"
                        :label="innerIndex"
                        @change="changeRadio(index, innerIndex)">正确答案</el-radio>
                    </el-col>
                  </el-row>
                  <el-button
                    size="small"
                    icon="el-icon-plus"
                    @click="AppendOptions(index)"
                  >
                    添加选项
                  </el-button>
                </el-col>
                <!--图文-->
                <el-col
                  v-else-if="options[index].optionsValue === 'imgTxt'"
                  :span="24">
                  <el-row
                    v-for="(item, innerIndex) in list.options"
                    :key="innerIndex">
                    <el-col :span="7">
                      <el-row>
                        <el-col :span="24">
                          <FileDialog
                            v-model="item.image"
                            :title="item.image"
                            token-url="/upload/token"
                            token-mode="type"
                            width="140px"
                            height="40px"
                            type="image"
                            preview
                          >
                            <span
                              slot="placeholder"
                              class="layout-placeholder"
                            >
                              选择图片
                            </span>
                          </FileDialog>
                        </el-col>
                      </el-row>
                    </el-col>
                    <el-col :span="7">
                      <el-row>
                        <el-col :span="24">
                          <el-input
                            v-model="item.text"
                            :autosize="true"
                            type="textarea"
                            resize="none"
                            class="optionsInput"
                            placeholder="请输入对应内容"
                          />
                          <AppIcon
                            type="delete"
                            @click="() => DeleteOptions(index, innerIndex)"
                          />
                        </el-col>
                      </el-row>
                    </el-col>
                    <el-col :span="3">
                      <el-radio
                        v-model="optionsIsTrue[index].isTrue"
                        :label="innerIndex"
                        @change="changeRadio(index, innerIndex)">正确答案</el-radio>
                    </el-col>
                  </el-row>
                  <el-button
                    size="small"
                    icon="el-icon-plus"
                    @click="AppendOptions(index)"
                  >
                    添加选项
                  </el-button>
                </el-col>
                <!--音文-->
                <el-col
                  v-else-if="options[index].optionsValue === 'audTxt'"
                  :span="24">
                  <el-row
                    v-for="(item, innerIndex) in list.options"
                    :key="innerIndex">
                    <el-col :span="7">
                      <el-row>
                        <el-col :span="24">
                          <FileDialog
                            v-model="item.audio"
                            :title="item.audio"
                            token-url="/upload/token"
                            token-mode="type"
                            width="140px"
                            height="40px"
                            type="audio"
                            preview
                          >
                            <span
                              slot="placeholder"
                              class="layout-placeholder"
                            >
                              选择音频
                            </span>
                          </FileDialog>
                        </el-col>
                      </el-row>
                    </el-col>
                    <el-col :span="7">
                      <el-row>
                        <el-col :span="24">
                          <el-input
                            v-model="item.text"
                            :autosize="true"
                            type="textarea"
                            resize="none"
                            class="optionsInput"
                            placeholder="请输入对应内容"
                          />
                          <AppIcon
                            type="delete"
                            @click="() => DeleteOptions(index, innerIndex)"
                          />
                        </el-col>
                      </el-row>
                    </el-col>
                    <el-col :span="3">
                      <el-radio
                        v-model="optionsIsTrue[index].isTrue"
                        :label="innerIndex"
                        @change="changeRadio(index, innerIndex)">正确答案</el-radio>
                    </el-col>
                  </el-row>
                  <el-button
                    size="small"
                    icon="el-icon-plus"
                    @click="AppendOptions(index)"
                  >
                    添加选项
                  </el-button>
                </el-col>
                <!--图音-->
                <el-col
                  v-else-if="options[index].optionsValue === 'imgAud'"
                  :span="24">
                  <el-row
                    v-for="(item, innerIndex) in list.options"
                    :key="innerIndex">
                    <el-col :span="7">
                      <el-row>
                        <el-col :span="24">
                          <FileDialog
                            v-model="item.image"
                            :title="item.image"
                            token-url="/upload/token"
                            token-mode="type"
                            width="140px"
                            height="40px"
                            type="image"
                            preview
                          >
                            <span
                              slot="placeholder"
                              class="layout-placeholder"
                            >
                              选择图片
                            </span>
                          </FileDialog>
                        </el-col>
                      </el-row>
                    </el-col>
                    <el-col :span="7">
                      <el-row>
                        <el-col :span="24">
                          <FileDialog
                            v-model="item.audio"
                            :title="item.audio"
                            token-url="/upload/token"
                            token-mode="type"
                            width="140px"
                            height="40px"
                            type="audio"
                            preview
                          >
                            <span
                              slot="placeholder"
                              class="layout-placeholder"
                            >
                              选择音频
                            </span>
                          </FileDialog>
                          <AppIcon
                            type="delete"
                            @click="() => DeleteOptions(index, innerIndex)"
                          />
                        </el-col>
                      </el-row>
                    </el-col>
                    <el-col :span="3">
                      <el-radio
                        v-model="optionsIsTrue[index].isTrue"
                        :label="innerIndex"
                        @change="changeRadio(index, innerIndex)">正确答案</el-radio>
                    </el-col>
                  </el-row>
                  <el-button
                    size="small"
                    icon="el-icon-plus"
                    @click="AppendOptions(index)"
                  >
                    添加选项
                  </el-button>
                </el-col>
                <!--图音文-->
                <el-col
                  v-else-if="options[index].optionsValue === 'all'"
                  :span="24">
                  <el-row
                    v-for="(item, innerIndex) in list.options"
                    :key="innerIndex">
                    <el-col :span="7">
                      <el-row>
                        <el-col :span="24">
                          <FileDialog
                            v-model="item.image"
                            :title="item.image"
                            token-url="/upload/token"
                            token-mode="type"
                            width="140px"
                            height="40px"
                            type="image"
                            preview
                          >
                            <span
                              slot="placeholder"
                              class="layout-placeholder"
                            >
                              选择图片
                            </span>
                          </FileDialog>
                        </el-col>
                      </el-row>
                    </el-col>
                    <el-col :span="7">
                      <el-row>
                        <el-col :span="24">
                          <FileDialog
                            v-model="item.audio"
                            :title="item.audio"
                            token-url="/upload/token"
                            token-mode="type"
                            width="140px"
                            height="40px"
                            type="audio"
                            preview
                          >
                            <span
                              slot="placeholder"
                              class="layout-placeholder"
                            >
                              选择音频
                            </span>
                          </FileDialog>
                        </el-col>
                      </el-row>
                    </el-col>
                    <el-col :span="7">
                      <el-row>
                        <el-col :span="24">
                          <el-input
                            v-model="item.text"
                            :autosize="true"
                            type="textarea"
                            resize="none"
                            class="optionsInput"
                            placeholder="请输入对应内容"
                          />
                          <AppIcon
                            type="delete"
                            @click="() => DeleteOptions(index, innerIndex)"
                          />
                        </el-col>
                      </el-row>
                    </el-col>
                    <el-col :span="3">
                      <el-radio
                        v-model="optionsIsTrue[index].isTrue"
                        :label="innerIndex"
                        @change="changeRadio(index, innerIndex)">正确答案</el-radio>
                    </el-col>
                  </el-row>
                  <el-button
                    size="small"
                    icon="el-icon-plus"
                    @click="AppendOptions(index)"
                  >
                    添加选项
                  </el-button>
                </el-col>
              </el-row>
            </el-col>
          </el-row>
        </el-col>
        <el-col :span="1">
          <AppIcon
            style="font-size: 24px;"
            type="delete"
            @click="() => recorderDelete(index)"
          />
        </el-col>
      </el-row>
    </el-form-item>
    <el-form-item
      class="game-list-editor__recorder-append"
    >
      <el-button
        type="primary"
        icon="el-icon-plus"
        plain
        round
        @click="recorderAppend"
      >
        添加游戏题目
      </el-button>
    </el-form-item>
  </el-form>
</template>

<script>
export default {
  name: "PlayConfig",
  props: {
    question: {
      type: Object,
      default: null,
    },
    list: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      config: {
        list: [
          {
            title: {
              image: [{ image: "" }],
              text: [{ text: "" }],
              audio: [{ audio: "" }],
            },
            options: [
              {
                image: "",
                text: "",
                audio: "",
                isTrue: "",
              },
            ],
          },
        ],
      },
      options: [
        {
          optionsSelect: [{
            value: "image",
            label: "图片",
          }, {
            value: "audio",
            label: "音频",
          }, {
            value: "text",
            label: "文本",
          }, {
            value: "imgTxt",
            label: "图文",
          }, {
            value: "audTxt",
            label: "音文",
          }, {
            value: "imgAud",
            label: "图音",
          }, {
            value: "all",
            label: "图音文",
          }],
          optionsValue: "",
        },
      ],
      optionsIsTrue: [{ isTrue: 0 }],
    };
  },
  created() {
    if (this.list !== null) {
      this.config.list = this.list.config;
      const optionsData = [];
      this.list.config.forEach(() => {
        optionsData.push({
          optionsSelect: [
            { value: "image", label: "图片" }, { value: "audio", label: "音频" },
            { value: "text", label: "文本" }, { value: "imgTxt", label: "图文" },
            { value: "audTxt", label: "音文" }, { value: "imgAud", label: "图音" },
            { value: "all", label: "图音文" },
          ],
          optionsValue: "",
        });
        this.optionsIsTrue.push({ isTrue: 0 });
      });
      this.options = optionsData;
      this.list.config.forEach((e, index) => {
        this.options[index].titleValue = e.titleType;
        this.options[index].optionsValue = e.optionsType;
        this.optionsIsTrue[index].isTrue = e.answer;
      });
    }
  },
  methods: {
    recorderAppend() {
      const num = this.question.question_number;
      if (this.config.list.length > num - 1 && num !== 0) {
        this.$alert(`最多只能添加${num}题！`);
      } else {
        this.config.list.push({
          title: {
            image: [{ image: "" }],
            text: [{ text: "" }],
            audio: [{ audio: "" }],
          },
          options: [
            {
              image: "",
              text: "",
              audio: "",
              isTrue: "",
            },
          ],
        });
        this.options.push({
          optionsSelect: [{
            value: "image",
            label: "图片",
          }, {
            value: "audio",
            label: "音频",
          }, {
            value: "text",
            label: "文本",
          }, {
            value: "imgTxt",
            label: "图文",
          }, {
            value: "audTxt",
            label: "音文",
          }, {
            value: "imgAud",
            label: "图音",
          }, {
            value: "all",
            label: "图音文",
          }],
          optionsValue: "",
        });
        this.optionsIsTrue.push({ isTrue: 0 });
      }
    },
    recorderDelete(index) {
      this.$confirm("是否删除题目？").then(() => {
        this.config.list.splice(index, 1);
        this.options.splice(index, 1);
      });
    },
    AppendTitle(index, type) {
      this.config.list[index].title[type].push({ [type]: "" });
    },
    DeleteTitle(index, innerIndex, type) {
      const item = this.config.list[index].title[type];
      if (item.length > 1) {
        item.splice(innerIndex, 1);
      }
    },
    AppendOptions(index, type) {
      const num = this.question.option_number;
      if (this.config.list[index].options.length > num - 1 && num !== 0) {
        this.$alert(`最多只能添加${num}个选项！`);
      } else {
        this.config.list[index].options.push({
          image: "",
          text: "",
          audio: "",
          isTrue: "",
        });
      }
    },
    DeleteOptions(index, innerIndex, type) {
      const item = this.config.list[index].options;
      if (item.length > 1) {
        item.splice(innerIndex, 1);
      }
    },
    changeOptions(index) {
      this.optionsIsTrue[index].isTrue = 0;
      this.config.list[index].answer = 0;
      this.config.list[index].options = [
        {
          image: "",
          text: "",
          audio: "",
          isTrue: "true",
        },
      ];
      this.config.list[index].optionsType = this.options[index].optionsValue;
    },
    changeRadio(index, innerIndex) {
      // eslint-disable-next-line no-return-assign,no-param-reassign
      this.config.list[index].options.map(item => item.isTrue = "");
      this.config.list[index].options[innerIndex].isTrue = "true";
      this.config.list[index].answer = this.optionsIsTrue[index].isTrue;
    },
  },
};
</script>

<style scoped>
    .config_box .config_box{
        padding-bottom: 10px;
        border-bottom: 1px dashed #ccc;
    }
    .game-list-editor__recorder-append{
        margin-top: 20px;
    }
    .game-list-editor__recorder{
        margin-bottom: 10px;
    }
    .optionsInput{
        display: inline-block;
        width: 140px;
        margin-right: 10px;
    }
  .app-qiniu{
    margin-right: 0 !important;
  }
  .el-radio{
    margin-left: 10px !important;
  }
</style>
